import {HomepageHeaderArenaTileDefaultBox} from "./home-page-header-arena-tile.default.box";
import {HomepageHeaderArenaTileSIBox} from "./home-page-header-arena-tile.si.box";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import {HomepageHeaderArenaTileCasino777Box} from "./home-page-header-arena-tile.casino777.box";
import {HomepageHeaderArenaTileCasino888Box} from "./home-page-header-arena-tile.casino888.box";

export const HomepageHeaderArenaTileBox = styledByTheme(HomepageHeaderArenaTileDefaultBox)
    .forCasino888(HomepageHeaderArenaTileCasino888Box)
    .forSI(HomepageHeaderArenaTileSIBox)
    .forCasino777(HomepageHeaderArenaTileCasino777Box)
    .apply();
